/** Keep browser login and member navigation on the same website. */
export function memberEntryUrl(liffId: string, inLine: boolean, botId = '1', asOrderId = '', loginIntent = false, join = false): string {
  const params = new URLSearchParams({ view: 'orders' })
  if (asOrderId) params.set('as', asOrderId)
  if (botId === '2') params.set('botId', '2')
  // มาจากการ์ดชวนสมัคร — คง join=1 ไว้จน login เสร็จ (หน้าสมาชิกเปิดฟอร์มสมัคร)
  if (join) params.set('join', '1')
  // ลูกค้ากดเข้าสู่ระบบเองบนเว็บ — ให้ต่างจาก URL เก่าที่ค้างในประวัติ (ซึ่งต้องไม่เด้งไป LINE เอง)
  if (loginIntent && !inLine) params.set('login', '1')
  return `${inLine ? `https://liff.line.me/${liffId}` : '/'}?${params}`
}

/** Never carry OAuth credentials or LIFF redirect state into a new login. */
export function orderLoginRedirectUrl(origin: string, orderId: string, botId: string): string {
  const url = new URL('/', origin)
  url.searchParams.set('page', 'customer-order')
  url.searchParams.set('orderId', orderId)
  if (botId === '2') url.searchParams.set('botId', '2')
  return url.toString()
}

/** A signed-in web customer continues on the same origin; LINE users stay in LIFF. */
export function orderEntryUrl(liffId: string, inLine: boolean, orderId: string, botId = '1', linkKey = ''): string {
  const params = new URLSearchParams({ orderId, page: 'customer-order' })
  if (botId === '2') params.set('botId', '2')
  // รหัสลับลิงก์ (&k=) — ออร์เดอร์ที่ค้นเจอด้วยเบอร์โทรไม่ใช่เจ้าของ LINE ต้องมี k ไม่งั้น orderAccess ตอบ 404
  if (linkKey) params.set('k', linkKey)
  return `${inLine ? `https://liff.line.me/${liffId}` : '/'}?${params}`
}
